const styles = `
.sales-terms {
  max-width: 760px;
  margin: 0 auto;
  padding: 40px 24px 96px;
  color: #0d0c0c;
  font-size: 17px;
  line-height: 1.6;
  -webkit-user-select: text;
  user-select: text;
}

.sales-terms h1 {
  margin: 0 0 12px;
  color: #000000;
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.2;
}

.sales-terms-updated {
  margin: 0 0 48px;
  color: #77716b;
  font-size: 14px;
}

.sales-terms h2 {
  margin: 44px 0 16px;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.25;
}

.sales-terms h3 {
  margin: 30px 0 12px;
  font-size: 18px;
  font-weight: 600;
}

.sales-terms p {
  margin: 0 0 16px;
}

.sales-terms-address {
  padding-left: 20px;
  border-left: 2px solid #e6e3de;
}

.sales-terms-list {
  margin: 0 0 16px;
  padding-left: 28px;
  list-style-type: lower-alpha;
}

.sales-terms-list li {
  margin-bottom: 8px;
  padding-left: 6px;
}

.sales-terms a {
  color: #000000;
  text-decoration: underline;
  text-underline-offset: 4px;
}
`;

export function SalesTerms() {
  return (
    <article className="sales-terms">
      <style>{styles}</style>
      <h1>VILKÅR FOR SALG AV GULL OG ANDRE EDELMETALLER TIL DAVID-ANDERSEN</h1>
      <p className="sales-terms-updated">Sist oppdatert: 5. august 2026</p>
      <h2>1. Om vilkårene og kjøperen</h2>
      <p>
        1.1 Disse vilkårene gjelder når en kunde selger gull eller andre avtalte edelmetaller med
        eller uten stener til David-Andersen AS, enten ved innlevering i en av David-Andersens
        butikker eller ved innsending med David-Andersens godkjente forsendelsesløsning.
      </p>
      <p>1.2 Kjøper er:</p>
      <p className="sales-terms-address">
        David-Andersen AS
        <br />
        Organisasjonsnummer: 985 172 277
        <br />
        Forretningsadresse: Karl Johans gate 20, 0159 Oslo
        <br />
        Postadresse: Postboks 773 Sentrum, 0106 Oslo
        <br />
        E-post: service.egertorget@david-andersen.no
        <br />
        Telefon: 24 14 88 00
      </p>
      <p>
        David-Andersen AS omtales nedenfor som «David-Andersen». Personen som tilbyr varer for salg,
        omtales som «Kunden».
      </p>
      <p>
        1.3 David-Andersen har nødvendige offentlige tillatelser og brukthandelbevillinger for
        virksomheten og de aktuelle fysiske butikkene.
      </p>
      <p>
        1.4 Ved registrering på Nettsiden eller innlevering av varer bekrefter Kunden å ha lest,
        forstått og akseptert disse vilkårene.
      </p>
      <h2>2. Definisjoner</h2>
      <p>I disse vilkårene betyr:</p>
      <ol className="sales-terms-list">
        <li>
          «Varen»: Gjenstanden eller gjenstandene Kunden tilbyr David-Andersen for salg, herunder
          smykker, mynter, barrer eller andre gjenstander som helt eller delvis består av gull eller
          andre edelmetaller som David-Andersen har opplyst at selskapet kjøper.
        </li>
        <li>
          «Forsendelsespakken»: Emballasje, sikkerhetspose, adresselapp og eventuell annen
          dokumentasjon som David-Andersen sender Kunden for innsending av Varen.
        </li>
        <li>
          «Forsendelsesløsningen»: Den transport- og innleveringsmåten David-Andersen til enhver tid
          har godkjent for innsending av Varer.
        </li>
        <li>
          «Registreringen»: Opplysningene Kunden registrerer på David-Andersens nettside om seg
          selv, Varen, betalingskontoen og forsendelsen.
        </li>
        <li>
          «Pristilbudet»: David-Andersens endelige tilbud om kjøp etter at Varen er mottatt,
          kontrollert og vurdert.
        </li>
        <li>
          «Prislisten»: David-Andersens til enhver tid gjeldende prisliste for gebyrer og
          tilleggstjenester knyttet til gullkjøpstjenesten.
        </li>
        <li>
          «Nettsiden»: David-Andersens nettside for registrering og salg av gull, for tiden
          www.david-andersen.no
        </li>
      </ol>
      <h2>3. Hvem som kan selge varer</h2>
      <p>3.1 Kunden må være minst 18 år og ha rettslig handleevne.</p>
      <p>
        3.2 Kunden må være rettmessig eier av Varen og ha full rett til å selge og disponere over
        den. Varen må ikke være stjålet, pantsatt, beheftet, underlagt utlegg eller tilhøre en annen
        person.
      </p>
      <p>
        3.3 Kunden kan ikke selge Varen på vegne av en annen person uten at David-Andersen på
        forhånd har godkjent dette og mottatt tilfredsstillende dokumentasjon på fullmakten og
        eierskapet.
      </p>
      <p>
        3.4 David-Andersen kjøper som hovedregel bare Varer fra privatpersoner med bostedsadresse og
        bankkonto i Norge. Kjøp fra næringsdrivende eller personer bosatt utenfor Norge krever
        særskilt avtale.
      </p>
      <p>
        3.5 Kunden skal legitimere seg på den måten David-Andersen krever. Dette kan blant annet
        skje med gyldig fysisk legitimasjon, elektronisk identifikasjon eller annen godkjent
        identitetskontroll.
      </p>
      <p>
        3.6 Kunden skal på forespørsel gi opplysninger og dokumentasjon om Varens opprinnelse,
        tidligere eierforhold og hvordan Kunden fikk Varen i sin besittelse.
      </p>
      <p>
        3.7 David-Andersen kan kontakte Kunden for å kontrollere identiteten, eierskapet,
        opplysningene i Registreringen, betalingskontoen eller andre forhold ved salget.
      </p>
      <h2>4. Registrering og innlevering</h2>
      <h3>4.1 Innsending med Posten</h3>
      <p>Ved innsending skal Kunden:</p>
      <ol className="sales-terms-list">
        <li>gjennomføre Registreringen på Nettsiden,</li>
        <li>gi korrekte og fullstendige opplysninger om seg selv og Varen,</li>
        <li>følge instruksjonene som følger med Forsendelsespakken,</li>
        <li>legge Varen i den tilsendte sikkerhetsposen og forsegle denne på riktig måte,</li>
        <li>benytte David-Andersens godkjente Forsendelsesløsning, og</li>
        <li>oppbevare innleveringskvitteringen frem til handelen er avsluttet.</li>
      </ol>
      <p>Kunden bør ta tydelige bilder av Varen før og etter den pakkes og sendes.</p>
      <h3>4.2 Innlevering i butikk</h3>
      <p>
        Ved innlevering i butikk skal Kunden identifisere seg via Vipps. Dersom identifikasjon via
        Vipps ikke gjennomføres eller ikke kan benyttes, skal Kunden fremvise gyldig legitimasjon og
        gi de opplysningene David-Andersen krever.
      </p>
      <p>Kunden mottar en kvittering eller annen bekreftelse på innleveringen.</p>
      <p>
        4.3 Registreringen og innleveringen innebærer at Kunden ber David-Andersen undersøke Varen
        og gi et mulig Pristilbud. David-Andersen er ikke forpliktet til å kjøpe Varen før et
        Pristilbud er gitt og akseptert.
      </p>
      <p>
        4.4 Kunden er ansvarlig for at alle opplysninger er riktige. Vesentlige avvik mellom
        Registreringen og den mottatte Varen kan medføre at behandlingen stanser eller at Varen
        returneres.
      </p>
      <p>
        4.5 Kunden skal ikke sende eller levere inn kontanter, dokumenter, personlige gjenstander
        eller andre varer som ikke inngår i den avtalte tjenesten.
      </p>
      <h2>5. Mottak og kontroll</h2>
      <p>
        5.1 David-Andersen registrerer mottaket og kan fotografere eller filme åpning, veiing,
        testing og håndtering av Varen. Dokumentasjonen kan brukes til kvalitetssikring, sikkerhet
        og behandling av eventuelle tvister.
      </p>
      <p>5.2 David-Andersen kan avvise eller utsette behandlingen dersom:</p>
      <ol className="sales-terms-list">
        <li>sikkerhetsposen eller emballasjen er skadet, åpnet eller manipulert,</li>
        <li>Varen eller antallet gjenstander avviker vesentlig fra Registreringen,</li>
        <li>nødvendig dokumentasjon mangler,</li>
        <li>Kundens identitet eller eierskap til Varen ikke kan bekreftes,</li>
        <li>det foreligger mistanke om straffbare forhold, eller</li>
        <li>Varen ikke er av en type David-Andersen kjøper.</li>
      </ol>
      <p>
        5.3 Dersom behandlingen stanses, kan David-Andersen kontakte Kunden for ytterligere
        opplysninger før det tas stilling til om Varen skal vurderes, holdes tilbake i samsvar med
        myndighetskrav eller returneres.
      </p>
      <p>
        5.4 David-Andersen har rett til å avslå kjøp av Varen uten å angi noen nærmere grunn, med de
        begrensningene som følger av gjeldende lovgivning.
      </p>
      <h2>6. Vurdering og testing</h2>
      <p>
        6.1 For å fastsette Varens metallinnhold, renhet og nettovekt kan David-Andersen eller en
        fagkyndig samarbeidspartner:
      </p>
      <ol className="sales-terms-list">
        <li>veie og måle Varen,</li>
        <li>undersøke stempler og merking,</li>
        <li>bruke røntgen-, syre-, slipe- eller andre kjemiske og tekniske testmetoder,</li>
        <li>file, ripe, bore eller på annen måte ta en mindre prøve av Varen,</li>
        <li>åpne, klippe eller demontere Varen, og</li>
        <li>
          skille edelmetall fra steiner, perler, urverk, fjærer, låser, fyllmaterialer og andre
          bestanddeler.
        </li>
      </ol>
      <p>
        6.2 Ved å akseptere disse vilkårene samtykker Kunden til at David-Andersen kan gjennomføre
        den testingen og behandlingen som er nødvendig for å fastsette Varens edelmetallinnhold og
        verdi.
      </p>
      <p>
        6.3 Kunden er innforstått med at testingen kan etterlate merker og medføre at Varen blir
        åpnet, filt, klippet eller demontert. Varen kan derfor ikke alltid settes sammen igjen eller
        returneres i sin opprinnelige tilstand.
      </p>
      <p>
        6.4 David-Andersen er ikke ansvarlig for skade, endring eller verdireduksjon som er en
        nødvendig og forsvarlig følge av testing eller demontering etter dette punktet. Dette
        gjelder ikke dersom skaden skyldes forsett eller uaktsomhet fra David-Andersens side.
      </p>
      <p>
        6.5 David-Andersen kan avstå fra destruktiv testing og returnere Varen dersom Varen fremstår
        som særlig verdifull utover metallverdien, eller dersom David-Andersen ellers vurderer at
        det ikke er forsvarlig å fortsette undersøkelsen.
      </p>
      <h2>7. Steiner, perler, urverk og andre materialer</h2>
      <p>
        7.1 Med mindre annet er uttrykkelig avtalt, kjøper David-Andersen bare det godkjente
        edelmetallinnholdet i Varen. Verdien av blant annet diamanter, andre edelstener, perler,
        emalje, urverk, glass, stål, fjærer, fyllmaterialer og andre metaller inngår ikke i
        kjøpesummen.
      </p>
      <p>
        7.2 Ved Registreringen kan Kunden velge hvordan steiner, urverk og andre bestanddeler enn
        edelmetall skal håndteres.
      </p>
      <p>7.3 Kunden kan velge mellom følgende alternativer:</p>
      <ol className="sales-terms-list">
        <li>
          at steiner, urverk og andre bestanddeler fjernes og disponeres av David-Andersen, eller
        </li>
        <li>
          at steiner, urverk og andre bestanddeler demonteres på en skånsom måte av en av
          David-Andersens gullsmeder og returneres til Kunden mot et tillegg i henhold til gjeldende
          prisliste.
        </li>
      </ol>
      <p>
        7.4 Eventuelle gebyrer og tillegg for demontering og retur fremgår av David-Andersens til
        enhver tid gjeldende prisliste. Gjeldende priser opplyses til Kunden før Registreringen
        fullføres.
      </p>
      <p>
        7.5 Valg av alternativ må foretas før David-Andersen starter vurderingen og behandlingen av
        Varen. Dersom Kunden ikke foretar et valg, legges alternativ a til grunn.
      </p>
      <p>
        7.6 Selv ved skånsom demontering kan gjenstandens konstruksjon, alder eller tilstand medføre
        at steiner, innfatninger, perler, urverk eller andre bestanddeler blir skadet eller ikke kan
        fjernes uten risiko for skade. David-Andersen kan derfor ikke garantere at slike
        bestanddeler kan demonteres eller returneres uskadde, med mindre skaden skyldes forsett
        eller uaktsomhet fra David-Andersens side.
      </p>
      <h2>8. Prisfastsettelse</h2>
      <p>8.1 Pristilbudet beregnes på grunnlag av:</p>
      <ol className="sales-terms-list">
        <li>Varens nettovekt av godkjent edelmetall,</li>
        <li>den renheten eller finheten David-Andersen fastsetter ved kontrollen, og</li>
        <li>
          David-Andersens til enhver tid gjeldende prisliste på det tidspunktet Varen blir
          kontrollert, analysert og veid.
        </li>
      </ol>
      <p>
        8.2 Prisene som vises på Nettsiden før Varen er undersøkt, er veiledende. Pristilbudet
        fastsettes på grunnlag av den gjeldende prislisten på tidspunktet Varen blir kontrollert,
        analysert og veid.
      </p>
      <p>
        8.3 Prisen gjelder som hovedregel bare edelmetallverdien. Det gis ikke betaling for design,
        merkevare, håndverk, samlerverdi, affeksjonsverdi eller andre egenskaper med mindre dette
        avtales skriftlig.
      </p>
      <p>
        8.4 Vekt av steiner, perler, låser, fjærer, urverk, fyllstoff, uekte deler og andre
        materialer inngår ikke i beregningen av kjøpesummen.
      </p>
      <p>8.5 Pristilbudet er gyldig i den fristen som fremgår av tilbudet.</p>
      <h2>9. Aksept eller avslag på Pristilbudet</h2>
      <p>
        9.1 Etter at Varen er mottatt, kontrollert og vurdert, gir David-Andersen Kunden et
        Pristilbud. Ved innsending gis Pristilbudet via e-post, SMS, kundeside eller annen avtalt
        kanal. Ved innlevering i butikk kan Pristilbudet gis muntlig under Kundens besøk.
      </p>
      <p>
        9.2 Pristilbudet skal vise den samlede kjøpesummen og kan også inneholde informasjon om
        Varens fastsatte vekt, renhet og andre forhold som har betydning for prisberegningen.
      </p>
      <p>
        9.3 Kunden må aktivt akseptere Pristilbudet på den måten som fremgår av meldingen fra
        David-Andersen. Registreringen eller innleveringen av Varen innebærer ikke at Kunden har
        akseptert den senere fastsatte kjøpesummen.
      </p>
      <p>
        9.4 Bindende avtale om salg inngås først når Kunden har akseptert Pristilbudet. Ved
        innsending skal aksept gis på den måten som fremgår av meldingen fra David-Andersen. Ved
        innlevering i butikk kan aksept gis muntlig eller på annen måte David-Andersen har lagt til
        rette for.
      </p>
      <p>
        9.5 Dersom Kunden avslår Pristilbudet innen fristen, returneres Varen i samsvar med punkt
        12.
      </p>
      <p>
        9.6 Dersom Kunden ikke svarer innen tilbudsfristen, sender David-Andersen minst én
        påminnelse. Dersom Kunden fortsatt ikke svarer innen 30 dager etter at Pristilbudet ble
        sendt, anses tilbudet som avslått, og Varen kan returneres til Kunden. Kunden kan belastes
        returgebyr i samsvar med punkt 12 og Prislisten.
      </p>
      <p>
        9.7 Kunden må som hovedregel akseptere eller avslå Pristilbudet for hele innsendingen
        samlet. Dersom David-Andersen gir separate tilbud for enkelte gjenstander eller grupper av
        gjenstander, kan tilbudene aksepteres eller avslås hver for seg.
      </p>
      <p>
        9.8 Ved innlevering i butikk kan vurderingen, Pristilbudet og Kundens aksept gjennomføres
        under samme besøk. Kunden skal få opplyst kjøpesummen før salget aksepteres.
      </p>
      <h2>10. Eiendomsrett og behandling etter aksept</h2>
      <p>10.1 Eiendomsretten til Varen går over til David-Andersen når:</p>
      <ol className="sales-terms-list">
        <li>Kunden har akseptert Pristilbudet, og</li>
        <li>David-Andersen har sendt eller gjennomført utbetalingen.</li>
      </ol>
      <p>
        10.2 Frem til vilkårene i punkt 10.1 er oppfylt, tilhører Varen Kunden, med de endringene
        som kan følge av avtalt testing og demontering.
      </p>
      <p>
        10.3 Etter at eiendomsretten har gått over til David-Andersen, kan Varen uten ytterligere
        varsel smeltes, raffineres, demonteres, omarbeides, videreselges eller på annen måte
        disponeres av David-Andersen.
      </p>
      <p>
        10.4 Kunden har ikke rett til å kreve Varen tilbake etter at eiendomsretten har gått over
        til David-Andersen.
      </p>
      <p>
        10.5 Salget er endelig når vilkårene i punkt 10.1 (a.) er oppfylt. Kunden har ikke en
        særskilt avtalefestet angrerett etter dette tidspunktet.
      </p>
      <h2>11. Utbetaling</h2>
      <p>
        11.1 Kjøpesummen utbetales ved overføring til bankkonto som Kunden har oppgitt og som
        David-Andersen har godkjent.
      </p>
      <p>
        11.2 Bankkontoen skal som hovedregel stå i Kundens navn. David-Andersen kan kreve
        dokumentasjon på kontoeierskapet og kan nekte utbetaling til en konto som tilhører en
        tredjeperson.
      </p>
      <p>11.3 Utbetaling skjer snarest mulig og senest innen 14 kalenderdager etter at:</p>
      <ol className="sales-terms-list">
        <li>Kunden har akseptert Pristilbudet,</li>
        <li>David-Andersen har mottatt alle nødvendige opplysninger fra Kunden, og</li>
        <li>nødvendige identitets-, eierskaps- og sikkerhetskontroller er avsluttet.</li>
      </ol>
      <p>
        11.4 Utbetalingen anses gjennomført når David-Andersen har gitt betalingsoppdraget til sin
        bank. Bankens behandlingstid kommer i tillegg.
      </p>
      <p>
        11.5 Kunden er ansvarlig for å oppgi korrekt kontonummer. David-Andersen er ikke ansvarlig
        for tap som skyldes uriktige opplysninger fra Kunden.
      </p>
      <p>
        11.6 Dersom opplysningene er ufullstendige, nødvendige kontroller ikke kan gjennomføres
        eller utbetalingen må utsettes som følge av lov, myndighetspålegg eller mistanke om
        straffbare forhold, begynner fristen i punkt 11.3 ikke å løpe før hindringen er bortfalt.
      </p>
      <p>
        11.7 David-Andersen foretar ikke kontantoppgjør. Kjøpesummen utbetales utelukkende ved
        overføring til bankkonto som er godkjent av David-Andersen, eller ved utstedelse av
        gavekort.
      </p>
      <h2>12. Retur</h2>
      <p>12.1 Varen returneres dersom:</p>
      <ol className="sales-terms-list">
        <li>Kunden avslår Pristilbudet,</li>
        <li>Kunden ikke aksepterer Pristilbudet innen fristene i punkt 9,</li>
        <li>David-Andersen velger å ikke kjøpe Varen,</li>
        <li>Varen faller utenfor tjenesten, eller</li>
        <li>partene ellers avtaler retur.</li>
      </ol>
      <p>
        12.2 Kunden kan bli belastet et returgebyr i henhold til Prislisten. Dette gjelder blant
        annet dersom:
      </p>
      <ol className="sales-terms-list">
        <li>Kunden avslår eller ikke aksepterer Pristilbudet,</li>
        <li>Kunden har gitt uriktige eller mangelfulle opplysninger,</li>
        <li>
          Kunden har brukt en annen forsendelsesmetode enn den godkjente Forsendelsesløsningen,
        </li>
        <li>Kunden har sendt inn gjenstander som faller utenfor tjenesten, eller</li>
        <li>Kunden har unnlatt å svare på henvendelser fra David-Andersen.</li>
      </ol>
      <p>
        12.3 Varen returneres i den tilstanden den befinner seg i etter avtalt testing og
        demontering. Kunden kan ikke kreve at Varen settes sammen eller tilbakeføres til sin
        opprinnelige tilstand.
      </p>
      <p>
        12.4 Dersom Kunden på forhånd har valgt retur av steiner, urverk eller andre bestanddeler,
        returneres disse sammen med eller separat fra den øvrige Varen. Returen skjer mot betaling i
        henhold til prisen Kunden fikk opplyst og aksepterte da valget ble foretatt.
      </p>
      <p>12.5 Retur skal skje med en sporbar og forsvarlig forsendelsesmetode.</p>
      <p>
        12.6 Returforsendelsen forsikres for dokumentert edelmetallverdi, begrenset oppad til kr 100
        000 per forsendelse.
      </p>
      <p>
        12.7 Dersom Varens dokumenterte verdi overstiger kr 100 000, skal Kunden og David-Andersen
        avtale en alternativ og forsvarlig utleverings- eller transportmåte. Kunden skal ikke sende
        inn Varer med antatt verdi over kr 100 000 uten særskilt avtale med David-Andersen.
      </p>
      <h2>13. Uavhentede eller ikke leverbare returer</h2>
      <p>
        13.1 Kunden er ansvarlig for å oppgi korrekt adresse og for å hente eller motta en
        returforsendelse innen transportørens frister.
      </p>
      <p>
        13.2 Dersom en returforsendelse kommer tilbake til David-Andersen, skal Kunden varsles via
        kontaktopplysningene Kunden har oppgitt.
      </p>
      <p>
        13.3 Kunden må innen tre måneder etter varselet avtale og betale for ny utsendelse eller
        annen utlevering, med mindre returen skyldes forhold David-Andersen er ansvarlig for.
      </p>
      <p>
        13.4 David-Andersen kan kreve dekket rimelige og dokumenterte kostnader til oppbevaring,
        administrasjon og ny utsendelse.
      </p>
      <p>
        13.5 Dersom Kunden, til tross for varsel fra David-Andersen, ikke gjør krav på Varen eller
        medvirker til at den kan returneres innen seks (6) måneder etter at det første varselet ble
        sendt, anses Kunden å ha oppgitt sitt krav på Varen. David-Andersen kan da disponere over
        Varen, herunder selge, gjenvinne eller destruere den, uten ytterligere varsel eller
        kompensasjon til Kunden.
      </p>
      <h2>14. Forsendelse, risiko og forsikring</h2>
      <p>
        14.1 Ved innsending med Posten skal Kunden benytte Forsendelsespakken og
        Forsendelsesløsningen som David-Andersen har sendt eller godkjent.
      </p>
      <p>14.2 David-Andersens ansvar for innsendingen gjelder bare dersom Kunden:</p>
      <ol className="sales-terms-list">
        <li>har pakket og forseglet Varen i samsvar med instruksjonene,</li>
        <li>har brukt den godkjente Forsendelsesløsningen, og</li>
        <li>har levert forsendelsen ved et godkjent innleveringssted.</li>
      </ol>
      <p>
        14.3 Forsendelsen er forsikret for dokumentert verdi med inntil kr 100 000 per forsendelse.
      </p>
      <p>
        14.4 Kunden skal ikke sende inn Varer med en antatt verdi som overstiger kr 100 000 uten at
        dette på forhånd er avtalt skriftlig med David-Andersen.
      </p>
      <p>
        14.5 Dersom Kunden sender inn Varer med en verdi som overstiger kr 100 000 uten særskilt
        avtale, er David-Andersens ansvar begrenset til kr 100 000.
      </p>
      <p>
        14.6 David-Andersen er ikke ansvarlig for forsendelser som sendes på annen måte enn gjennom
        den godkjente Forsendelsesløsningen, med mindre annet følger av ufravikelig lov.
      </p>
      <p>
        14.7 Ved tap eller skade skal Kunden melde fra til David-Andersen uten ugrunnet opphold og
        gi de opplysningene og den dokumentasjonen som med rimelighet er nødvendig for å undersøke
        saken.
      </p>
      <p>14.8 Dokumentasjon ved et erstatningskrav kan blant annet omfatte:</p>
      <ol className="sales-terms-list">
        <li>sporingsnummer eller annen dokumentasjon som identifiserer forsendelsen,</li>
        <li>bilder av Varen tatt før innsending og i forseglet pose,</li>
        <li>kjøpskvittering, takst eller annen dokumentasjon som belyser Varens verdi,</li>
        <li>opplysninger om Varen, herunder vekt, stempler og produkttype, og</li>
        <li>
          annen dokumentasjon som David-Andersen eller forsikringsgiveren med rimelighet krever.
        </li>
      </ol>
      <p>
        14.9 Erstatning ved tap eller skade er begrenset til dokumentert økonomisk verdi og
        maksimalt kr 100 000 per forsendelse. Affeksjonsverdi, forventet fortjeneste og indirekte
        tap erstattes ikke.
      </p>
      <h2>15. Mistanke om tyvegods, bedrageri eller andre straffbare forhold</h2>
      <p>
        15.1 David-Andersen kan avstå fra kjøp, stanse utbetaling, holde tilbake Varen eller utsette
        retur dersom dette er nødvendig eller tillatt etter lov, pålegg fra myndigheter eller
        selskapets sikkerhetsrutiner.
      </p>
      <p>
        15.2 David-Andersen kan registrere og utlevere relevante opplysninger til politiet og andre
        offentlige myndigheter når dette følger av lov, myndighetspålegg eller et gyldig
        behandlingsgrunnlag.
      </p>
      <p>
        15.3 Mistanke om tyveri, heleri, bedrageri, hvitvasking, bruk av falsk identitet, falsk
        dokumentasjon eller andre straffbare forhold kan bli anmeldt.
      </p>
      <p>
        15.4 Politiet kan kontrollere varer og opplysninger i samsvar med brukthandelsregelverket og
        øvrig gjeldende lovgivning.
      </p>
      <p>
        15.5 At David-Andersen gjennomfører undersøkelser eller ber om ytterligere dokumentasjon,
        innebærer ikke i seg selv at Kunden er mistenkt for en straffbar handling.
      </p>
      <h2>16. Personopplysninger</h2>
      <p>
        16.1 David-Andersen er behandlingsansvarlig for personopplysninger som behandles i
        forbindelse med gullkjøpstjenesten.
      </p>
      <p>16.2 Personopplysninger kan blant annet behandles for å:</p>
      <ol className="sales-terms-list">
        <li>registrere og identifisere Kunden,</li>
        <li>kontrollere Kundens identitet og rett til å selge Varen,</li>
        <li>administrere Registreringen, vurderingen og kjøpsavtalen,</li>
        <li>kommunisere med Kunden,</li>
        <li>gjennomføre utbetaling og regnskapsføring,</li>
        <li>oppfylle krav etter brukthandelsregelverket og annet relevant regelverk,</li>
        <li>forebygge og avdekke misbruk og straffbare handlinger,</li>
        <li>ivareta sikkerhet og dokumentasjon, og</li>
        <li>håndtere returer, reklamasjoner og tvister.</li>
      </ol>
      <p>
        16.3 Behandlingen skjer på det behandlingsgrunnlaget som er relevant for det enkelte
        formålet. Dette kan blant annet være at behandlingen er nødvendig for å inngå eller oppfylle
        avtalen, oppfylle en rettslig forpliktelse eller ivareta en berettiget interesse.
      </p>
      <p>
        16.4 Samtykke benyttes bare som behandlingsgrunnlag der David-Andersen vurderer at samtykke
        er nødvendig og egnet. Aksept av disse vilkårene utgjør ikke et generelt personvernsamtykke.
      </p>
      <p>
        16.5 Opplysninger kan deles med transportører, banker, analyse- og raffineringsselskaper,
        IT-leverandører, forsikringsselskaper, profesjonelle rådgivere og offentlige myndigheter når
        dette er nødvendig og lovlig.
      </p>
      <p>
        16.6 Personopplysninger lagres ikke lenger enn nødvendig for det aktuelle formålet, men kan
        oppbevares så lenge dette følger av regnskapsregler, brukthandelsregelverket,
        dokumentasjonskrav eller andre rettslige forpliktelser.
      </p>
      <p>
        16.7 Nærmere informasjon om behandlingen av personopplysninger og Kundens rettigheter finnes
        i David-Andersens{" "}
        <a
          href="https://david-andersen.no/retningslinjer/personvern/"
          target="_blank"
          rel="noreferrer"
        >
          personvernerklæring
        </a>
        .
      </p>
      <p>
        16.8 Aksept av vilkårene innebærer ikke at Kunden samtykker til markedsføring. Markedsføring
        skjer bare dersom David-Andersen har et gyldig behandlingsgrunnlag og, når loven krever det,
        et separat samtykke.
      </p>
      <h2>17. Kommunikasjon</h2>
      <p>
        17.1 David-Andersen kan kommunisere med Kunden via e-post, SMS, telefon, kundeside eller
        ordinær post ved bruk av kontaktopplysningene Kunden har gitt.
      </p>
      <p>
        17.2 Kunden er ansvarlig for å oppgi riktige og oppdaterte kontaktopplysninger og for å
        kontrollere meldinger, herunder søppelpostfilter.
      </p>
      <p>
        17.3 En elektronisk melding anses mottatt når den er sendt til e-postadressen eller
        telefonnummeret Kunden har oppgitt, med mindre David-Andersen mottar beskjed om at
        leveringen mislyktes.
      </p>
      <p>
        17.4 Kunden skal uten ugrunnet opphold melde fra om endringer i navn, adresse,
        telefonnummer, e-postadresse eller bankkonto.
      </p>
      <h2>18. David-Andersens ansvar</h2>
      <p>
        18.1 David-Andersen er ansvarlig for direkte og dokumentert økonomisk tap som skyldes at
        David-Andersen har brutt avtalen eller opptrådt uaktsomt, innenfor begrensningene i disse
        vilkårene og ufravikelig lov.
      </p>
      <p>18.2 David-Andersen er ikke ansvarlig for:</p>
      <ol className="sales-terms-list">
        <li>affeksjonsverdi,</li>
        <li>forventet fortjeneste eller indirekte tap,</li>
        <li>
          design-, merkevare-, samler- eller kunstverdi som ikke inngår i David-Andersens vurdering,
        </li>
        <li>nødvendig og forsvarlig testing eller demontering,</li>
        <li>tap som skyldes uriktige eller mangelfulle opplysninger fra Kunden, eller</li>
        <li>tap utover den avtalte forsikringsdekningen.</li>
      </ol>
      <p>
        18.3 Begrensningene gjelder ikke ved forsett eller grov uaktsomhet eller dersom de strider
        mot ufravikelig lov.
      </p>
      <p>
        18.4 Dersom David-Andersen blir forhindret fra å oppfylle avtalen på grunn av forhold
        utenfor selskapets rimelige kontroll, suspenderes forpliktelsene så lenge hindringen varer.
        Dette kan blant annet gjelde myndighetspålegg, krig, alvorlige sikkerhetshendelser,
        naturkatastrofer, omfattende streik, brann, transportstans eller langvarig svikt i nødvendig
        infrastruktur.
      </p>
      <p>
        18.5 David-Andersen skal informere Kunden uten ugrunnet opphold dersom en slik hindring får
        vesentlig betydning for behandlingen av Kundens sak.
      </p>
      <h2>19. Reklamasjoner og kontakt</h2>
      <p>
        19.1 Kunden skal kontrollere Pristilbudet, utbetalingen og eventuelle returforsendelser og
        melde fra om feil uten ugrunnet opphold.
      </p>
      <p>19.2 Spørsmål og reklamasjoner kan rettes til:</p>
      <p className="sales-terms-address">
        David-Andersen AS
        <br />
        E-post: service.egertorget@david-andersen.no
        <br />
        Telefon: 24 14 88 00
        <br />
        Postadresse: Postboks 773 Sentrum, 0106 Oslo
      </p>
      <p>
        19.3 En reklamasjon bør inneholde Kundens navn, referansenummer, en beskrivelse av forholdet
        og relevant dokumentasjon.
      </p>
      <p>19.4 Denne bestemmelsen begrenser ikke rettigheter Kunden har etter ufravikelig lov.</p>
      <h2>20. Endringer i vilkårene og Prislisten</h2>
      <p>
        20.1 David-Andersen kan endre vilkårene med virkning for nye registreringer og
        innleveringer.
      </p>
      <p>
        20.2 Vilkårene som Kunden aksepterte ved Registreringen eller innleveringen, gjelder for den
        aktuelle saken. Senere endringer får ikke tilbakevirkende kraft.
      </p>
      <p>
        20.3 David-Andersen kan endre Prislisten. Den prisen eller det gebyret Kunden ble opplyst om
        og aksepterte før Registreringen eller før den aktuelle tilleggstjenesten ble valgt, gjelder
        for Kundens sak.
      </p>
      <h2>21. Lovvalg og tvisteløsning</h2>
      <p>21.1 Avtalen er underlagt norsk rett.</p>
      <p>21.2 Partene skal først forsøke å løse eventuelle uenigheter i minnelighet.</p>
      <p>
        21.3 Kunden kan kontakte relevante offentlige klage- eller veiledningsorganer dersom saken
        faller innenfor deres myndighetsområde.
      </p>
      <p>
        21.4 Tvister som ikke løses i minnelighet, kan bringes inn for norske domstoler. Verneting
        fastsettes etter de alminnelige reglene i tvisteloven. En forbruker kan ikke fratas et
        verneting som følger av ufravikelig lov.
      </p>
    </article>
  );
}
